import { render, staticRenderFns } from "./TagBadge.vue?vue&type=template&id=dc85337a&scoped=true&"
var script = {}
import style0 from "./TagBadge.vue?vue&type=style&index=0&id=dc85337a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc85337a",
  null
  
)

export default component.exports